import React, { Fragment } from 'react'
import IconPng from 'atoms/IconPng'
import { Label, Paragraph, TxtLink } from 'atoms/Texts'
import GridPhotos from 'molecules/GridPhotos'
import {
  SlotContainer,
  CardMessage,
  CardMsgFlex,
  ItemRoundedGreen,
  LineTop,
  LineBot,
  LeftSlot,
  RightSlot,
  DateSlot,
  Chips,
  CardTitleSlot,
  CardContentSlot,
  RowSlot
} from './styles'
import {
  COLLABORATION_REMARK,
  COLLABORATION_IMAGE,
  COLLABORATION_DOCUMENT,
  COLLABORATION_DEPARTMENT,
  COLLABORATION_PARTIAL_CLOSE,
  COLLABORATION_OPEN_ISSUE,
  COLLABORATION_SHARED_ISSUE,
  COLLABORATION_ADD_CC,
  COLLABORATION_REOPEN
} from 'fixtures/collabTypes'
import { SERVER_URL } from 'fixtures/api'
import { withTheme } from 'styled-components'
import moment from 'moment'
import ic_doc from 'App/assets/images/ic-file-doc.png'
import ic_sheet from 'App/assets/images/ic-file-sheet.png'
import ic_pdf from 'App/assets/images/ic-file-pdf.png'
import ic_image from 'App/assets/images/ic-file-image.png'

const icons = {
  ic_share_orange: require('App/assets/images/ic_share_orange.png'),
  ic_pic_orange: require('App/assets/images/ic_pic_orange.png'),
  ic_doc_orange: require('App/assets/images/ic_doc_orange.png'),
  ic_doc_bk: require('App/assets/images/ic_doc_bk.png'),
  ic_remarks_orange: require('App/assets/images/ic_remarks_orange.png')
}

const FILE_TYPE_ICONS = {
  png: ic_image,
  jpg: ic_image,
  doc: ic_doc,
  docx: ic_doc,
  xls: ic_sheet,
  xlsx: ic_sheet,
  pdf: ic_pdf,
}

const dateFormat = (date) => moment(moment.utc(date).toDate()).local().format("DD MMMM YYYY, LT")

const MsgContent = ({ type, content, theme, title }) => {
  const switchDisplay = () => {
    const data = {
      displayIcon: '',
      comp: <div />
    }
    switch (type) {
      case COLLABORATION_REMARK:
        data.displayIcon = icons.ic_remarks_orange
        data.comp = <Paragraph weight={'400'} mb={'0'}>{content}</Paragraph>
        break;
      case COLLABORATION_DEPARTMENT:
        data.displayIcon = icons.ic_share_orange
        data.comp = content.map((el, i) => (
          <Chips key={i}>
            <Label
              size={'12px'}
              lineheight={'14px'}
              weight={'400'}
              color={theme.white}
              mb={'0'}
            >
              {el.nameDisplay}
            </Label>
          </Chips>
        ))
        break;
      case COLLABORATION_IMAGE:
        data.displayIcon = icons.ic_pic_orange
        data.comp = <GridPhotos photos={content} previewOnClick />
        break;
      case COLLABORATION_DOCUMENT:
        data.displayIcon = icons.ic_doc_orange
        data.comp = (
          <div style={{ flex: 1 }}>
            {content.map((el, i) => (
              <CardMsgFlex key={i}>
                <IconPng srcIcon={icons.ic_doc_bk} ml={'0'} size={'auto'} h={'15'} />
                <div style={{ paddingLeft: 12, flex: 1 }}>
                  <TxtLink
                    size={'12px'}
                    lineheight={'14px'}
                    weight={'400'}
                    color={theme.mocaGrey}
                    isNewTab={true}
                    href={`${SERVER_URL}${el.url}`}
                  >
                    {el.nameDisplay}
                  </TxtLink>
                </div>
              </CardMsgFlex>
            ))}
          </div>
        )
        break;
      case COLLABORATION_ADD_CC:
        data.displayIcon = icons.ic_share_orange
        data.comp = content.map((el, i) => (
          <Chips key={i}>
            <Label
              size={'12px'}
              lineheight={'14px'}
              weight={'400'}
              color={theme.white}
              mb={'0'}
            >
              {el.displayName}
            </Label>
          </Chips>
        ))
        break;
      case COLLABORATION_PARTIAL_CLOSE:
        const mainContent = content.find(c => c.displayName)
        const contents = content.filter(c => !c.displayName)
        const { comment } = content.find(c => !!c.comment) || {}
        data.displayIcon = icons.ic_share_orange
        data.comp =
          <div>
            <Paragraph weight={'400'} mb={'5px'}>{comment}</Paragraph>
            {
              mainContent.rootCause &&
                <Paragraph weight={'400'} mb={'5px'}>
                  <Label size="12px" color={theme.mocaOrange}>Root Cause:&nbsp;</Label>
                  {mainContent.rootCause}
                </Paragraph>}
            {
              mainContent.corrective &&
                <Paragraph weight={'400'} mb={'5px'}>
                  <Label size="12px" color={theme.mocaOrange}>Corrective:&nbsp;</Label>
                  {mainContent.corrective}
                </Paragraph>}
            {
              mainContent.preventive &&
                <Paragraph weight={'400'} mb={'5px'}>
                  <Label size="12px" color={theme.mocaOrange}>Preventive:&nbsp;</Label>
                  {mainContent.preventive}
                </Paragraph>}
            <div>
              {
                contents.map((el, i) => (
                  <div style={{ marginBottom: '5px' }}>
                    <TxtLink
                      size={'12px'}
                      lineheight={'14px'}
                      weight={'400'}
                      color={theme.mocaGrey}
                      href={`${SERVER_URL}${el.url}`}
                      title={el.nameDisplay}
                      isNewTab
                    >
                      <IconPng srcIcon={FILE_TYPE_ICONS[el.ext.toLowerCase()]} alt={el.nameDisplay || el.name} size={'auto'} h={'24'} mr={'10px'} />
                      {el.nameDisplay || el.name}
                    </TxtLink>
                  </div>
                ))
              }
            </div>
          </div>
        break;
      case COLLABORATION_REOPEN:
        data.comp =
          <Paragraph weight={'400'} mb={'5px'}>
            <Label size="12px" color={theme.mocaOrange}>Reason:&nbsp;</Label>
            {content.reason}
          </Paragraph>
        break;
      default:
        break;
    }

    return data
  }

  const { displayIcon, comp } = switchDisplay()

  return (
    <CardMessage>
      {type === COLLABORATION_OPEN_ISSUE || type === COLLABORATION_SHARED_ISSUE ?
        <RowSlot>
          <Label lineheight={'14px'} size={'12px'} mb={'0'}>
            {content.displayName}
          </Label> &nbsp;
          <Label lineheight={'14px'} size={'12px'} color={theme.mocaGreen} mb={'0'}>
            {content.remark}
          </Label> &nbsp;
          <Label lineheight={'14px'} size={'12px'} mb={'0'}>
            the issue
          </Label>
          {type === COLLABORATION_SHARED_ISSUE &&
            <Fragment>
              <Label lineheight={'14px'} size={'12px'} mb={'0'}>
                &nbsp;with&nbsp;
              </Label>
              <Label lineheight={'14px'} size={'12px'} color={theme.mocaOrange} mb={'0'}>
                {content.departmentName}
              </Label>
            </Fragment>
          }
        </RowSlot> :

        type === COLLABORATION_PARTIAL_CLOSE ?
          <div>
            <div>
              <Label lineheight={'14px'} size={'12px'} mb={'0'}>
                {content.find(c => !!c.displayName).displayName}
              </Label> &nbsp;
              <Label lineheight={'14px'} size={'12px'} color={theme.mocaOrange} mb={'0'}>
                ({content.find(c => !!c.departmentName).departmentName})  &nbsp;
              </Label>
              <Label lineheight={'14px'} size={'12px'} color={theme.mocaGreen} mb={'0'}>
                {title}
              </Label>
            </div>
            <CardContentSlot mt="0">
              {comp}
            </CardContentSlot>
          </div> :

          type === COLLABORATION_REOPEN ?
            <div>
              <div>
                <Label lineheight={'14px'} size={'12px'} mb={'0'}>
                  {content.displayName}
                </Label>&nbsp;
                <Label lineheight={'14px'} size={'12px'} color={theme.mocaOrange} mb={'0'}>
                  ({content.departmentName}) &nbsp;
                </Label>
                <Label lineheight={'14px'} size={'12px'} color={theme.mocaGreen} mb={'0'}>
                  {content.remark}
                </Label>&nbsp;
                <Label lineheight={'14px'} size={'12px'} mb={'0'}>
                  the issue
                </Label>
              </div>
              <CardContentSlot mt="0">
                {comp}
              </CardContentSlot>
            </div> :

            <Fragment>
              <IconPng srcIcon={displayIcon} ml={'0'} size={'auto'} h={'15'} />
              <CardTitleSlot>
                <Label color={theme.mocaOrange} mb={'0'}>{title}</Label>
                <CardContentSlot>
                  {comp}
                </CardContentSlot>
              </CardTitleSlot>
            </Fragment>
      }
    </CardMessage>
  )
}

const MsgContainer = ({ first, last, createdAt, theme, ...rest }) => {
  return (
    <SlotContainer>
      <LeftSlot>
        <ItemRoundedGreen />
        <LineTop first={first} />
        <LineBot last={last} />
      </LeftSlot>
      <RightSlot>
        <DateSlot>
          <Label
            size={'12px'}
            lineheight={'14px'}
            weight={'400'}
            color={theme.mocaGrey}
            mb={'0'}
          >
            {dateFormat(createdAt)}
          </Label>
        </DateSlot>
        <MessageContent {...rest} />
      </RightSlot>
    </SlotContainer>
  )
}

const MessageContent = withTheme(MsgContent)
const MessageContainer = withTheme(MsgContainer)
export { MessageContent, MessageContainer }
